// eslint-disable-next-line @nx/enforce-module-boundaries
import { DOCUMENT_TOKEN, WINDOW_TOKEN } from "@intocare/auth-data";

export function windowFactory() {
	return window;
}

export function documentFactory() {
	return document;
}

export function navigatorFactory() {
	return navigator;
}

export const NAVIGATOR_TOKEN = "navigator";

export const BROWSER_PROVIDERS = [
	{ provide: WINDOW_TOKEN, useFactory: windowFactory },
	{ provide: DOCUMENT_TOKEN, useFactory: documentFactory },
	{ provide: NAVIGATOR_TOKEN, useFactory: navigatorFactory },
];
